import React from 'react';
import { useTranslation } from 'react-i18next';

const ReadbackPanel: React.FC = () => {
  const { t } = useTranslation('webflash');

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        {t('readback.title')}
      </h3>
      <div className="flex flex-wrap gap-3">
        <button
          disabled
          className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium disabled:opacity-50"
        >
          {t('readback.readFlash')}
        </button>
        <button
          disabled
          className="px-4 py-2 bg-gray-600 text-white rounded-lg text-sm font-medium disabled:opacity-50"
        >
          {t('readback.readRegion')}
        </button>
        <button
          disabled
          className="px-4 py-2 bg-gray-600 text-white rounded-lg text-sm font-medium disabled:opacity-50"
        >
          {t('readback.download')}
        </button>
      </div>
    </div>
  );
};

export default ReadbackPanel;
